<app-worker-select
  #workerSelect
  [assistanceURID]="assistanceURID"
  [assistanceRange]="assistanceRange"
  [isEnabled]="true"
  [isModal]="true"
  [filterOverrides]="filterOverrides"
  (availabilitiesChanged)="updateAssistants($event)"
  (availabilitiesRemoved)="removeAssistants($event)"
  (closed)="onClose(true)"
  (closedWithoutChanges)="onClose(false)"
></app-worker-select>
